import React,{useEffect, useState,useRef} from "react";
import Main from "../../components/template/Main";
import { login_Id,empresa_Id } from "../../store/config/dadosuser";
import { get,put,post } from "../../store/config/register";
import { parse,format } from "date-fns";
import { FiX,FiFile,FiUserPlus } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import { toBase64,replaceType } from "../../util/Imagem";
import Compressor from "compressorjs";
import { toast } from "react-toastify";

const headerProps = {
    icon: 'calendar',
    title: 'Minhas Reservas'
  }

export default function MinhasReservas() {

   const [agendamentos,setAgendamentos]= useState([]);
   const [templateEmailCancelamento,setTemplateEmailCancelamento]= useState({});
   const [espacos,setEspacos] = useState([]);
   const hiddenFileInput = useRef(null);
   const [agendaSelecionada,setAgendaSelecionada]=useState({})
   let hoje =new Date().setHours(0,0,0,0);
   const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
   
   
       function getWindowDimensions() {
         const { innerWidth: width, innerHeight: height } = window;
         return {
           width,
           height
         };
       }
       
   
       
         useEffect(() => {
           function handleResize() {
             setWindowDimensions(getWindowDimensions());
           }
       
           window.addEventListener('resize', handleResize);
           return () => window.removeEventListener('resize', handleResize);
         }, []);


   const history = useHistory();

        async function buscaAgendamento(){
          const agen = await get(`/EspacoAgenda/v1/Login?login_id=${login_Id}&empresa_id=${empresa_Id}`)
          if(agen.length > 0){
            setAgendamentos(agen)
          }
        }

        async function buscaEspacos(){
          const esp = await get(`/Espaco/v1/Empresa/${empresa_Id}`)
          if(esp.length > 0){
            setEspacos(esp)
          }
        }

        async function BuscaTemplateCancelamento(idEmpresa) {
          let result =await get('/Template/v1?tipo=7&empresa='+idEmpresa);
          setTemplateEmailCancelamento(result);
          return result;
         }
    
        useEffect(()=>{
          buscaAgendamento();
          buscaEspacos();
          BuscaTemplateCancelamento(empresa_Id);
        },[])


        async function AtualizaAgenda(pagamento, agendaEscolhida) {
          let agend =await get('/EspacoAgenda/v1/'+ agendaEscolhida.id)
          agend.pagamento =pagamento;
          await put('/EspacoAgenda/v1/'+ agendaEscolhida.id,agend)
          await toast.success('Pagamento anexado com sucesso');
          await  buscaAgendamento();
          window.location.reload();
        }

        async function cancelarReserva(item){
          await put(`/EspacoAgenda/v1/Cancelar/${item.id}`);
          toast.success('Reserva cancelada.')
          await enviarEmail(item,2)
          await buscaAgendamento();
          window.location.reload();
      }

      async function enviarEmail(item, tipo){
        let emails =[];
         emails.push(item.email);     
         let data={};
         
         
         if(tipo === 2) {
          templateEmailCancelamento.template =templateEmailCancelamento.template.replace('@responsavel',item.responsavel);
          templateEmailCancelamento.template =templateEmailCancelamento.template.replace('@espaco',item.espaco);
          templateEmailCancelamento.template =templateEmailCancelamento.template.replace('@espaco',item.espaco);
          templateEmailCancelamento.template =templateEmailCancelamento.template.replace('@unidade',`${item.unidade} - ${item.bloco}`);
          templateEmailCancelamento.template =templateEmailCancelamento.template.replace('@data',format(parse(item.data,"yyyy-MM-dd'T'HH:mm:ss",new Date()),'dd/MM/yyyy HH:mm'));
          data =  { sender:emails, subject: templateEmailCancelamento.assunto,html: templateEmailCancelamento.template,empresa_id: empresa_Id}
        }

        let result = await post('/Email/v1',data);
        await toast.success('email enviado com sucesso');
      }

        function anexarComprovante(agenda){
          setAgendaSelecionada(agenda);
          hiddenFileInput.current.click(agenda);
        }

        function convidadoAgenda(Id){
          history.push('/ReservaEspaco/Convidado/'+ Id)
      }
      
        async function handleFile(e ){
      
          if(e.target.files[0]) {
              const image = e.target.files[0];
      
                
                let type='';
                if(image.type === 'image/jpeg' || image.type === 'image/png' || image.type === 'application/pdf'){
      
                       if(image.type === 'image/jpeg' || image.type === 'image/png'){
                        new Compressor( image, {
                          quality: 0.6, // 0.6 can also be used, but its not recommended to go below.
                          success: async( compressedResult) => {
                            // compressedResult has the compressed file.
                            // Use the compressed file to upload the images to your server.        
                            type = compressedResult.type;
                            let base64 = await toBase64(compressedResult);    
                            let resp =  replaceType(base64);
                            agendaSelecionada.tipo = compressedResult.type;
                           await AtualizaAgenda(resp,agendaSelecionada);
                        },
                        });
                       }else{
                        type =image.type;
                        let base64 = await toBase64(image);  
                        let resp =  replaceType(base64);
                        agendaSelecionada.tipo = image.type;
                       await AtualizaAgenda(resp,agendaSelecionada);
                       }
                
          }
                  }else{
                      alert('Envie uma imagem do tipo PNG ou JPEG');
                  }
      }

    function renderTable() {
        return (
          <div className='tabela'>
                      <table>
                        <thead>
                        
                          {windowDimensions.width > 576 ? (
                              <tr>
                            <th scope="col" className="Data">Data</th>
                            <th scope="col" className="Unidade">Unidade</th>     
                            <th scope="col" className="Espaco">Espaço</th>
                            <th scope="col"></th>
                            </tr>
                          ):
                          (
                            <tr>
                            <th scope="col" className="Data">Data</th>
                            <th scope="col" className="Unidade">Unidade</th>     
                            <th scope="col" className="Espaco">Espaço</th>
                            <th scope="col" >Anexar Comprovante</th>
                            <th scope="col" >Cancelar Reserva</th>
                            <th scope="col" >Adicionar Convidados</th>
                            </tr>
                          )
                        }
                        </thead>

                        <tbody>
                          {agendamentos.length === 0 ? null : agendamentos.map((agenda,index) => {

                              let espaco = espacos.filter(f => f.id === agenda.espaco_Id);
                              let cancelamento = 0;
                              let convidado =  false;
    
                              if(espaco.length > 0){
                                 cancelamento = hoje + (espaco[0].desistencia*60*60*1000);
                                 convidado = espaco[0].lista_Convidado;
                              }
                                 

                              var horario = format(parse(agenda.data,"yyyy-MM-dd'T'HH:mm:ss",new Date()),'dd/MM/yyyy');

                              horario = parse(horario,'dd/MM/yyyy', new Date()).getTime();
                            return (
                              <tr key={index}>
                                  <td data-label="Data">{format(parse(agenda.data,"yyyy-MM-dd'T'HH:mm:ss",new Date()),'dd/MM/yyyy HH:mm')}</td>
                                  <td data-label="Unidade">{agenda.unidade} - {agenda.bloco}</td>
                                  <td data-label="Espaço">{agenda.espaco}</td>
                                  {windowDimensions.width > 576 ? (
                                      <td  data-label="">
                                      <div >
                                      <input type="file"  onChange={e => handleFile(e)} ref={hiddenFileInput} style={{display: 'none'}}/>  
                                      </div>                                 
                                     
                                         <button className="action"  style={{backgroundColor: '#228B22' ,marginRight: "10px" }} data-toggle="tooltip" data-placement="bottom" title="Anexar Comprovante" onClick={() => anexarComprovante(agenda)}>
                                        <FiFile color="#FFF" size={17} />
                                        </button>
    
                                             <button className="action"  style={{backgroundColor: '#ff0000' ,marginRight: "10px" }} data-toggle="tooltip" data-placement="bottom" title="Cancelar Reserva" onClick={async() => await cancelarReserva(agenda)}>
                                             <FiX color="#FFF" size={17} />
                                             </button>
                                          
                                      { convidado && (
                                          <button className="action"  style={{backgroundColor: '#4682B4' ,marginRight: "10px" }} data-toggle="tooltip" data-placement="bottom" title="Adicionar Convidados" onClick={async() => await convidadoAgenda(agenda.id)(agenda)}>
                                          <FiUserPlus color="#FFF" size={17} />
                                          </button>
                                        )}
                                        </td>
                                  ):(
                                  <div>

                              
                                  <td  data-label="Anexar Comprovante">
                                  <div >
                                  <input type="file"  onChange={e => handleFile(e)} ref={hiddenFileInput} style={{display: 'none'}}/>  
                                  </div>                                 
                                 
                                     <button className="action"  style={{backgroundColor: '#228B22' ,marginRight: "10px" }} data-toggle="tooltip" data-placement="bottom" title="Anexar Comprovante" onClick={() => anexarComprovante(agenda)}>
                                    <FiFile color="#FFF" size={17} />
                                    </button>
                                    </td>
                                    <td  data-label="Cancelar Reserva">
                                         <button className="action"  style={{backgroundColor: '#ff0000' ,marginRight: "10px" }} data-toggle="tooltip" data-placement="bottom" title="Cancelar Reserva" onClick={async() => await cancelarReserva(agenda)}>
                                         <FiX color="#FFF" size={17} />
                                         </button>
                                         </td>
                                         <td  data-label="Adicionar Convidados">
                                  { convidado && (
                                      <button className="action"  style={{backgroundColor: '#4682B4' ,marginRight: "10px" }} data-toggle="tooltip" data-placement="bottom" title="Adicionar Convidados" onClick={async() => await convidadoAgenda(agenda.id)(agenda)}>
                                      <FiUserPlus color="#FFF" size={17} />
                                      </button>
                                    )}
                                    </td>
                               
                                    </div>
                                  )}
                                 
                                </tr>
                            );
                          })}
                                
  
  
                        </tbody>
                      </table>
  
                    </div>
        );
    }

    function renderForm(){
        return (
            <div className="form">
               {renderTable()}
               <hr/>
              <div className="row1">
                  <button className="btn btn-primary" onClick={e => history.push('/Reservas')}>
                    Nova Reserva
                  </button>
                  <button className="btnSairCad btn-primary" onClick={e => history.push('/Menu')}>
                    Voltar
                  </button>
                </div>
         
           
        </div>
        );
    }

    return(
        <Main {...headerProps}>
            {renderForm()}
        </Main>
    );
}
